<script setup lang="ts">
import type { TabItem } from '@/shared/models/shared.model'

import TabUnderlineItem from '@/shared/components/tab/TabUnderlineItem.vue'

interface Props {
  items: TabItem[]
  loading?: boolean
}

defineProps<Props>()
defineOptions({ inheritAttrs: false })

const model = defineModel<number>({ required: true })
</script>

<template>
  <div class="text-sm text-center pb-2">
    <ul
      class="flex flex-wrap gap-1 border-b"
      :class="loading ? 'border-gray-500/30' : 'border-gray-500'"
      v-bind="$attrs"
    >
      <li v-for="(item, index) in items" :key="index">
        <TabUnderlineItem
          v-model="model"
          :index="index"
          :label="item.label"
          :loading="loading"
          :disabled="item.disabled"
        />
      </li>
    </ul>
  </div>
</template>
